'use client'

import React, { useEffect, useState } from 'react'
import { useRef } from 'react'
import { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
import Link from 'next/link'
import CardSliderIcon from './CardSliderIcon'
import CardSliderSwiper from './CardSliderSwiper'

type Props = {
    setVideoOpen?: (state: boolean) => void
    setGalleryOpen?: (state: boolean) => void
    list: {
        items: {
            title: string
            text: string[]
            cardClass: string
        }[]
        btn: {
            content: string
            link?: string
            icon?: string
            isBlank?: boolean
        }
        btn2?: {
            content: string
            link?: string
            icon?: string
            isBlank?: boolean
        }
    }
    headSlider: string[]
    aboutCompany?: boolean
}

const CardSlider: React.FC<Props> = ({ list, headSlider, aboutCompany, setVideoOpen, setGalleryOpen }) => {
    const swiperRef = useRef<SwiperType>()
    const [selectedChapter, setSelectedChapter] = useState(0)
    const [headerSliderMargin, setHeaderSliderMargin] = useState(0)
    const [headerSliderScroll, setHeaderSliderScroll] = useState(0)

    const headSliderNext = () => {
        setHeaderSliderScroll(headerSliderScroll - headerSliderMargin - 2)
    }

    const headSliderPrev = () => {
        setHeaderSliderScroll(0)
    }

    useEffect(() => {
        const headSliderElement = document.querySelector('.product__head-slider')
        const headSliderLimiterElement = document.querySelector('.product__head-slider-limiter')

        const marginChange = () => {
            if (headSliderElement && headSliderLimiterElement) {
                const headSliderWidth = headSliderElement.clientWidth
                const headSliderLimiterWidth = headSliderLimiterElement.clientWidth

                const difference = headSliderWidth - headSliderLimiterWidth

                setHeaderSliderMargin(difference)
            }
        }
        marginChange()
    }, [headerSliderMargin])

    const changeChapter = (num: number) => {
        setSelectedChapter(num)
        swiperRef.current.slideTo(num)
    }

    return (
        <div className='card-slider__wrapper'>
            <div
                onClick={() => swiperRef.current.slidePrev()}
                className={'product__slider-nav product__slider-nav_prev'}
            >
                <svg
                    style={{ transform: 'rotate(180deg)' }}
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M19.7071 10.7071C20.0976 10.3166 20.0976 9.68342 19.7071 9.29289L13.3431 2.92893C12.9526 2.53841 12.3195 2.53841 11.9289 2.92893C11.5384 3.31945 11.5384 3.95262 11.9289 4.34314L17.5858 10L11.9289 15.6569C11.5384 16.0474 11.5384 16.6805 11.9289 17.0711C12.3195 17.4616 12.9526 17.4616 13.3431 17.0711L19.7071 10.7071ZM1 9C0.447716 9 1.44847e-07 9.44771 0 10C-1.44847e-07 10.5523 0.447715 11 1 11L1 9ZM19 9L1 9L1 11L19 11L19 9Z'
                        fill='#C1CCE2'
                    />
                </svg>
            </div>
            <div
                onClick={() => swiperRef.current.slideNext()}
                className='product__slider-nav product__slider-nav_next'
            >
                <svg
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M19.7071 10.7071C20.0976 10.3166 20.0976 9.68342 19.7071 9.29289L13.3431 2.92893C12.9526 2.53841 12.3195 2.53841 11.9289 2.92893C11.5384 3.31945 11.5384 3.95262 11.9289 4.34314L17.5858 10L11.9289 15.6569C11.5384 16.0474 11.5384 16.6805 11.9289 17.0711C12.3195 17.4616 12.9526 17.4616 13.3431 17.0711L19.7071 10.7071ZM1 9C0.447716 9 1.44847e-07 9.44771 0 10C-1.44847e-07 10.5523 0.447715 11 1 11L1 9ZM19 9L1 9L1 11L19 11L19 9Z'
                        fill='#C1CCE2'
                    />
                </svg>
            </div>
            <div className='card-slider__container'>
                <div
                    style={headerSliderMargin < 10 ? { maxWidth: '100%' } : { maxWidth: '95%' }}
                    className={`product__head-slider-limiter`}
                >
                    <ul
                        style={{ marginLeft: `${headerSliderScroll}px` }}
                        className={`product__head-slider `}
                    >
                        {headSlider?.map((slide, index) => (
                            <li
                                onClick={() => changeChapter(index)}
                                className={
                                    selectedChapter === index
                                        ? 'product__head-slide categories-slider__text'
                                        : 'product__head-slide'
                                }
                                key={index}
                            >
                                {slide}
                            </li>
                        ))}
                        <li
                            onClick={headerSliderScroll === 0 ? headSliderNext : headSliderPrev}
                            style={headerSliderScroll === 0 ? {} : { transform: 'rotate(180deg)' }}
                            className='product__head-arrow'
                        >
                            {headerSliderMargin > 25 && (
                                <>
                                    <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                            stroke='#83A3EB'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                        />
                                    </svg>
                                </>
                            )}
                        </li>
                    </ul>
                </div>
                <CardSliderSwiper
                    swiperRef={swiperRef}
                    setSelectedChapter={setSelectedChapter}
                    aboutCompany={aboutCompany}
                    items={list.items}
                />
            </div>
            <div className='card-slider__mobile-nav'>
                <div
                    onClick={() => swiperRef.current.slidePrev()}
                    className='card-slider__mobile-nav_prev'
                >
                    <svg
                        width='21'
                        height='21'
                        viewBox='0 0 21 21'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M0.792893 9.79289C0.402369 10.1834 0.402369 10.8166 0.792893 11.2071L7.15685 17.5711C7.54738 17.9616 8.18054 17.9616 8.57107 17.5711C8.96159 17.1805 8.96159 16.5474 8.57107 16.1569L2.91421 10.5L8.57107 4.84315C8.96159 4.45262 8.96159 3.81946 8.57107 3.42893C8.18054 3.03841 7.54738 3.03841 7.15685 3.42893L0.792893 9.79289ZM19.5 11.5C20.0523 11.5 20.5 11.0523 20.5 10.5C20.5 9.94772 20.0523 9.5 19.5 9.5V11.5ZM1.5 11.5L19.5 11.5V9.5L1.5 9.5L1.5 11.5Z'
                            fill='#83A3EB'
                        />
                    </svg>
                </div>
                <div
                    onClick={() => swiperRef.current.slideNext()}
                    className='card-slider__mobile-nav_next'
                >
                    <svg
                        width='21'
                        height='21'
                        viewBox='0 0 21 21'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M20.2071 11.2071C20.5976 10.8166 20.5976 10.1834 20.2071 9.79289L13.8431 3.42893C13.4526 3.03841 12.8195 3.03841 12.4289 3.42893C12.0384 3.81945 12.0384 4.45262 12.4289 4.84314L18.0858 10.5L12.4289 16.1569C12.0384 16.5474 12.0384 17.1805 12.4289 17.5711C12.8195 17.9616 13.4526 17.9616 13.8431 17.5711L20.2071 11.2071ZM1.5 9.5C0.947716 9.5 0.5 9.94771 0.5 10.5C0.5 11.0523 0.947715 11.5 1.5 11.5L1.5 9.5ZM19.5 9.5L1.5 9.5L1.5 11.5L19.5 11.5L19.5 9.5Z'
                            fill='#83A3EB'
                        />
                    </svg>
                </div>
            </div>
            <div className='main-about__card-buttons'>
                {list.btn.link ? (
                    <Link
                        {...(list.btn?.isBlank ? { target: '_blank' } : '')}
                        href={list.btn.link}
                    >
                        <button className='main-about__card-button main__card-button'>
                            {list.btn?.icon && (
                                <div>
                                    <CardSliderIcon
                                        icon={list.btn.icon}
                                        icon1={list.btn.icon}
                                    />
                                </div>
                            )}
                            {list.btn.content}
                        </button>
                    </Link>
                ) : (
                    <button
                        onClick={() => (list.btn.icon === 'video' ? setVideoOpen(true) : setGalleryOpen(true))}
                        className='main-about__card-button main__card-button'
                    >
                        {list.btn.icon && (
                            <CardSliderIcon
                                icon={list.btn.icon}
                                icon1={list.btn.icon}
                            />
                        )}
                        {list.btn.content}
                    </button>
                )}
                {list.btn2 && list.btn2?.link ? (
                    <Link
                        {...(list.btn2.isBlank ? { target: '_blank' } : '')}
                        href={list.btn2.link}
                    >
                        <button className='main-about__card-button main__card-button'>
                            {list.btn2?.icon && (
                                <CardSliderIcon
                                    icon={list.btn2.icon}
                                    icon1={list.btn.icon}
                                />
                            )}
                            {list.btn2?.content}
                        </button>
                    </Link>
                ) : (
                    list.btn2 && (
                        <button
                            onClick={() => (list.btn2.icon === 'video' ? setVideoOpen(true) : setGalleryOpen(true))}
                            className='main-about__card-button main__card-button'
                        >
                            {list.btn2?.icon && (
                                <CardSliderIcon
                                    icon={list.btn2.icon}
                                    icon1={list.btn.icon}
                                />
                            )}
                            {list.btn2?.content}
                        </button>
                    )
                )}
            </div>
        </div>
    )
}

export default CardSlider
